import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NgbTooltipModule } from '@ng-bootstrap/ng-bootstrap';
import { AdminCompaniesComponent } from './admin-companies.component';
import { CompaniesComponent } from './companies.component';
import { CoreModule } from 'src/app/core/core.module';
import { CreateCompanyComponent } from './create-company/create-company.component';
import { ReactiveFormsModule } from '@angular/forms';
import { SplideSliderComponent } from 'src/app/core/components/splide-slider/splide-slider.component';

@NgModule({
  imports: [
    CommonModule,
    CoreModule,
    NgbTooltipModule,
    ReactiveFormsModule,
    SplideSliderComponent
  ],
  providers: [
  ],
  declarations: [CompaniesComponent, AdminCompaniesComponent, CreateCompanyComponent]
})
export class CompaniesModule { }
